export default __webpack_public_path__ + "static/11.12-ef96a7839f47d9012ae258d5f692336b.png";